<p>almacen-equipos works!</p>
